export const PATHS = {
  account: 'account',
  admin: {
    customers: 'customers',
    feedback: 'feedback',
    homepage: '/kh39sk39_dsf952',
    mlTasks: 'ml-tasks',
    recordingDetail: 'recordings/:recordingId',
    recordingDetailLink: (recordingId: string) => `/kh39sk39_dsf952/recordings/${recordingId}`,
    recordings: 'recordings',
    survey: 'survey',
  },
  any: '*',
  auth: 'auth',
  checkout: 'checkout',
  folders: 'folders',
  glossaries: 'glossaries',
  homepage: '/',
  pricing: 'pricing',
  project: 'project',
  recordingDetail: 'recording/:recordId',
  recordingDetailLink: (recordId: string) => `/recording/${recordId}`,
  recordingEntry: 'recording-entry',
  recordingShare: 'share/recording/:sharing_id',
  recordingShareLink: (sharingId: string) => `/share/recording/${sharingId}`,
  records: 'records',
  spaces: 'spaces',
  trialShare: 'share/:sharing_id',
  voices: 'voices',
} as const;
